$(document).ready(function() {
  // Function to check if screen width is 1079px or less
  function isSmallScreen() {
    return $(window).width() <= 1079;
  }
  
  // Function to handle all screen-size dependent changes
  function handleScreenSizeChanges() {
    if (isSmallScreen()) {
      console.log("Screen is 1079px or smaller");
      
      // Hide carousel elements
      $('#NavigationTier2-1-mobMobileNav > ul > li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel > cc-carousel > div.cc-carousel__scroll-outer > div > div:nth-child(4)').hide();
      $('#NavigationTier2-2-mobMobileNav > ul > li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel > cc-carousel > div.cc-carousel__scroll-outer > div > div:nth-child(4)').hide();
      $('#NavigationTier2-3-mobMobileNav > ul > li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel > cc-carousel > div.cc-carousel__scroll-outer > div > div:nth-child(4)').hide();
      $('#NavigationTier2-4-mobMobileNav > ul > li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel > cc-carousel > div.cc-carousel__scroll-outer > div > div:nth-child(4)').hide();
      $('#NavigationTier2-5-mobMobileNav > ul > li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel > cc-carousel > div.cc-carousel__scroll-outer > div > div:nth-child(4)').hide();
      
      // Menu Item 1
      const $navList1 = $('#NavigationTier2-1-mobMobileNav > ul');
      const $carouselItem1 = $navList1.find('li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel');
      
      // Only move if it's not already in the 3rd position
      if ($carouselItem1.length && $carouselItem1.index() !== 2) {
        // Get the element that should be at the 3rd position (0-based index 2)
        const $thirdItem1 = $navList1.children('li').eq(2);
        // Insert the carousel before the current 3rd item
        $carouselItem1.insertBefore($thirdItem1);
        console.log("Moved carousel element to 3rd position for Menu Item 1");
      }


      // Menu Item 2
      const $navList2 = $('#NavigationTier2-2-mobMobileNav > ul');
      const $carouselItem2 = $navList2.find('li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel');
      
      // Only move if it's not already in the 5th position
      if ($carouselItem2.length && $carouselItem2.index() !== 4) {
        // Get the element that should be at the 5th position (0-based index 4)
        const $fifthItem2 = $navList2.children('li').eq(4);
        // Insert the carousel before the current 5th item
        $carouselItem2.insertBefore($fifthItem2);
        console.log("Moved carousel element to 5th position for Menu Item 2");
      }

      // Menu Item 3
      const $navList3 = $('#NavigationTier2-3-mobMobileNav > ul');
      const $carouselItem3 = $navList3.find('li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel');
      
      // Only move if it's not already in the 3rd position
      if ($carouselItem3.length && $carouselItem3.index() !== 2) {
        // Get the element that should be at the 3rd position (0-based index 2)
        const $thirdItem3 = $navList3.children('li').eq(2);
        // Insert the carousel before the current 3rd item
        $carouselItem3.insertBefore($thirdItem3);
        console.log("Moved carousel element to 3rd position for Menu Item 3");
      }

      // Menu Item 4
      const $navList4 = $('#NavigationTier2-4-mobMobileNav > ul');
      const $carouselItem4 = $navList4.find('li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel');
      
      // Only move if it's not already in the 2nd position
      if ($carouselItem4.length && $carouselItem4.index() !== 1) {
        // Get the element that should be at the 2nd position (0-based index 1)
        const $secondItem4 = $navList4.children('li').eq(1);
        // Insert the carousel before the current 2nd item
        $carouselItem4.insertBefore($secondItem4);
        console.log("Moved carousel element to 2nd position for Menu Item 4");
      }

      // Menu Item 5
      const $navList5 = $('#NavigationTier2-5-mobMobileNav > ul');
      const $carouselItem5 = $navList5.find('li.navigation__column.navigation__column--promotion.navigation__column--promotion-carousel');
      
      // Only move if it's not already in the 4th position - FIXED THE MISSING PARENTHESIS HERE
      if ($carouselItem5.length && $carouselItem5.index() !== 3) {
        // Get the element that should be at the 4th position (0-based index 3)
        const $fourthItem5 = $navList5.children('li').eq(3);
        // Insert the carousel before the current 4th item
        $carouselItem5.insertBefore($fourthItem5);
        console.log("Moved carousel element to 4th position for Menu Item 5");
      }
    } 
  }
  
  // Initial call when page loads
  handleScreenSizeChanges();
  
  // Check again if window is resized
  $(window).resize(function() {
    handleScreenSizeChanges();
  });
});